import { render, staticRenderFns } from "./localLoading-component.vue?vue&type=template&id=bcd85f66"
import script from "./localLoading-component.vue?vue&type=script&lang=ts"
export * from "./localLoading-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports